import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,  
  Radio,
  Label,
  Message,
} from 'semantic-ui-react';
import _ from 'lodash';
import { userConstants } from '../../constants/user.constants';
import PropTypes from 'prop-types';
import { notificationActions } from '../../actions/notification.actions';

class NotificationConfigFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notificationConfig: {    
        name: '',
        typeid: "",
        message: "",
        args: "",
        enabled: true,
        blockaction: 0,
      },
      errors: {},
      submitted: false,      
    };    
  }

  componentDidMount() {
    const { match, dispatch } = this.props;    
    if (match.params.id) {
        dispatch(notificationActions.get(match.params.id))
            .then(() => {                
                const notificationConfig = _.mapKeys(this.props.notificationConfig, function (v, k) { return k.toLowerCase(); });                
                this.setState({ notificationConfig })
            });
    }    
    dispatch(notificationActions.fetchTypes());
  }

  static get propTypes() { 
    return {       
        me: PropTypes.any,        
        notificationConfig: PropTypes.any,
        loading: PropTypes.bool,
        match: PropTypes.any,
    }; 
  }

  handleChange(field, data) {            
    const { notificationConfig } = this.state;    
    notificationConfig[field] = data;    
    this.setState({ notificationConfig });    
  }

  validate() {
    const { notificationConfig } = this.state;
    
    let errors = {};
    let valid = true;

    if (!notificationConfig.name || notificationConfig.name.length == 0) {
      errors.name = "Preencha o nome";
      valid = false;
    }

    if (!notificationConfig.message || notificationConfig.message.length == 0) {
      errors.name = "Preencha a mensagem";
      valid = false;
    }

    if (!notificationConfig.typeid || notificationConfig.typeid <= 0) {
      errors.typeid = "Escolha um tipo";
      valid = false;
    }

    if (!notificationConfig.args) {
      errors.args = "Preencha o tempo";
      valid = false;
    }
    
    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { notificationConfig } = this.state;    
    delete notificationConfig.type;

    if (notificationConfig.id) {
        dispatch(notificationActions.update(notificationConfig.id, notificationConfig));
    } else {
        dispatch(notificationActions.create(notificationConfig));
    }
  }

  render() {    
    const { notificationConfig, errors } = this.state;     
    const { notificationTypes, me } = this.props;

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    const blockActionOptions = [
      { key: 0, value: 0, text: "Nenhuma ação" },
      { key: 1, value: 1, text: "Logoff" },
      { key: 2, value: 2, text: "Bloqueio" },
    ];
    
    let typeOptions = []
    if (notificationTypes) {
      typeOptions = notificationTypes.map((type) => {
        return {
        value: type.Id,
        text: type.Name,
        key: type.Id,
      }});
    } else if (notificationConfig) {
      typeOptions.push({
        value: notificationConfig.typeid,
        key: notificationConfig.typeid,
        text: notificationConfig.type.Name,
      });
    }
    
    return (  
      <Fragment>
      <h1>Configuração de Notificação</h1>
      <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
        <Form.Select required error={errors.typeid} label='Tipo' value={notificationConfig.typeid} name='typeid' onChange={(e, data) => this.handleChange("typeid", data.value)} options={typeOptions} />

        <Form.Input required error={errors.name} label='Nome' value={notificationConfig.name} name='name' type='text' onChange={(e, data) => this.handleChange("name", data.value)} placeholder='Nome da configuração' />
        { errors.name && <Label color='red'>{errors.name}</Label>}

        <Form.Group>
          <Form.TextArea width={16} rows={12} required error={errors.message} label='Mensagem' value={notificationConfig.message} name='message' type='text' onChange={(e, data) => this.handleChange("message", data.value)} placeholder='Mensagem enviada para o usuário' />
          { errors.message && <Label color='red'>{errors.message}</Label>}
                
          <Message size='small' width={4}>  
            <Message.Header>Máscaras</Message.Header>
            <Message.List>
              <Message.Item><b>[nome_usuario]</b> - Nome do Usuário</Message.Item>
              <Message.Item><b>[email_usuario]</b> - E-Mail do Usuário</Message.Item>
              <Message.Item><b>[username_usuario]</b> - Username do Usuário</Message.Item>
              <Message.Item><b>[horario_inicio_jornada]</b> - Horário Efetivo de Início da Jornada</Message.Item>    
              <Message.Item><b>[horario_fim_jornada]</b> - Horário de Fim da Jornada Regular (sem tolerância de saída)</Message.Item>                
              <Message.Item><b>[horario_limite_jornada]</b> - Horário em que o bloueio será aplicado</Message.Item>              
            </Message.List>                            
          </Message>
        </Form.Group>

        <Form.Input required error={errors.args} label='Tempo (minutos) para aviso' value={notificationConfig.args} name='args' type='text' onChange={(e, data) => this.handleChange("args", data.value)} placeholder='' />
        { errors.args && <Label color='red'>{errors.args}</Label>}

        <Form.Select required error={errors.blockAction} label='Ação' value={notificationConfig.blockaction} name='blockaction' onChange={(e, data) => this.handleChange("blockaction", data.value)} options={blockActionOptions} />
      
        <Form.Input>
            <Radio toggle checked={notificationConfig.enabled} label='Habilitada' onChange={(e, data) => this.handleChange("enabled", data.checked)} />
        </Form.Input>
                
        <Button primary type='submit'>{notificationConfig.id ? 'Alterar' : 'Criar'} Configuração</Button>
      </Form>
    </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, notification } = state;  
  let props = {
    me: users.me || null,    
    loading: notification.loading,
    notificationTypes: notification.notificationTypes ? notification.notificationTypes.Results : [],
  };

  if (notification && notification.notificationConfig) {
      props.notificationConfig = notification.notificationConfig;      
  }
     
  return props;
}

const connectedNotificationConfigFormScreen = connect(mapStateToProps)(NotificationConfigFormScreen);
export { connectedNotificationConfigFormScreen as NotificationConfigFormScreen };
